(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["so-collection-product-grid"] && !Shopify.designMode) return;
  try {
    
  if (!window.referenceCollectionGridAjax) {
    window.referenceCollectionGridAjax = true;
    let collectionRequest;

    async function renderCollectionGrid(grid, url, pushState) {
      if (!grid) return;

      if (collectionRequest) collectionRequest.abort();
      collectionRequest = new AbortController();
      grid.setAttribute('aria-busy', 'true');

      try {
        const requestUrl = new URL(url, window.location.origin);
        requestUrl.searchParams.set('section_id', grid.id.replace('CollectionGrid-', ''));
        const response = await fetch(requestUrl.toString(), {
          signal: collectionRequest.signal,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
        if (!response.ok) throw new Error('Collection section request failed');

        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const replacement = parsed.getElementById(grid.id);
        if (!replacement) throw new Error('Collection section was missing from the response');

        grid.replaceWith(replacement);
        if (pushState) {
          const cleanUrl = new URL(url, window.location.origin);
          cleanUrl.searchParams.delete('section_id');
          window.history.pushState({ collectionGrid: true }, '', cleanUrl.toString());
        }
      } catch (error) {
        if (error.name !== 'AbortError') window.location.assign(url);
      } finally {
        const currentGrid = document.getElementById(grid.id);
        if (currentGrid) currentGrid.removeAttribute('aria-busy');
      }
    }

    document.addEventListener('click', function (event) {
      const link = event.target.closest('[data-collection-grid] .cg-filter, [data-collection-grid] .cg-pagination a');
      if (!link || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const grid = link.closest('[data-collection-grid]');
      if (!grid) return;
      event.preventDefault();
      renderCollectionGrid(grid, link.href, true);
    });

    document.addEventListener('change', function (event) {
      if (!event.target.matches('[data-collection-sort] select')) return;
      const grid = event.target.closest('[data-collection-grid]');
      if (!grid) return;
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      url.searchParams.delete('page');
      renderCollectionGrid(grid, url.toString(), true);
    });

    window.addEventListener('popstate', function () {
      document.querySelectorAll('[data-collection-grid]').forEach(function (grid) {
        renderCollectionGrid(grid, window.location.href, false);
      });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["so-related-products"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class ProductRecommendations extends HTMLElement {
      connectedCallback() {
        const url = this.dataset.url;
        if (!url || this.dataset.loaded === 'true') return;
        this.dataset.loaded = 'true';

        fetch(url)
          .then((response) => {
            if (!response.ok) throw new Error('Product recommendations request failed');
            return response.text();
          })
          .then((html) => {
            const documentHtml = new DOMParser().parseFromString(html, 'text/html');
            const recommendations = documentHtml.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            } else {
              this.hidden = true;
            }
          })
          .catch(() => { this.hidden = true; });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
